import { render, staticRenderFns } from "./CompositeListSelect.vue?vue&type=template&id=680894dc&scoped=true&"
import script from "./CompositeListSelect.vue?vue&type=script&lang=js&"
export * from "./CompositeListSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680894dc",
  null
  
)

export default component.exports